/* ============================================================
   Social Keychain — theme.js
============================================================ */
const SK = (() => {

  // ── Cart — Shopify API ──

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        const count = data.item_count;
        const el = document.getElementById('cartCount');
        if (el) el.textContent = count;
        const fEl = document.getElementById('floatingCartCount');
        if (fEl) {
          const prev = fEl.textContent;
          fEl.textContent = count;
          // bump animation only when count actually increases
          if (parseInt(prev, 10) < count) {
            fEl.classList.add('bump');
            setTimeout(() => fEl.classList.remove('bump'), 300);
          }
        }
      })
      .catch(() => {});
  }

  function renderCartDrawer() {
    const list = document.getElementById('cartItemsList');
    const footer = document.getElementById('cartFooter');
    if (!list) return;

    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        const I = window.SK_I18N || {};
        const el = document.getElementById('cartCount');
        if (el) el.textContent = data.item_count;

        if (data.items.length === 0) {
          list.innerHTML = `<div class="cart-empty"><div style="font-size:3rem;margin-bottom:0.8rem">🛒</div><h3>${I.cart_empty || 'Your cart is empty'}</h3><p style="margin-top:0.3rem">${I.cart_empty_sub || 'Add a keychain to get started.'}</p></div>`;
          if (footer) footer.style.display = 'none';
        } else {
          list.innerHTML = data.items.map(i => `
            <div class="cart-item">
              <div class="cart-item-img">
                ${i.image ? `<img src="${i.image}" alt="${i.product_title}" style="width:100%;height:100%;object-fit:cover;border-radius:8px;">` : '🔑'}
              </div>
              <div>
                <div class="cart-item-name">${i.product_title}</div>
                <div class="cart-item-variant">${i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title + ' · ' : ''}${I.cart_qty || 'Qty:'} ${i.quantity}</div>
                ${i.properties && i.properties['Your URL'] ? `<div style="font-size:0.72rem;margin-top:0.2rem;display:flex;align-items:center;gap:0.3rem;"><span style="font-size:0.65rem;text-transform:uppercase;letter-spacing:0.06em;font-weight:600;font-family:'Syne',sans-serif;color:var(--muted);">URL</span><a href="${i.properties['Your URL']}" target="_blank" rel="noopener" style="color:var(--muted);text-decoration:underline;text-underline-offset:3px;word-break:break-all;">${i.properties['Your URL']}</a></div>` : ''}
              </div>
              <div class="cart-item-price">${formatMoney(i.line_price)}</div>
            </div>
          `).join('');
          const totalEl = document.getElementById('cartTotal');
          if (totalEl) totalEl.textContent = formatMoney(data.total_price);
          if (footer) footer.style.display = 'block';
        }
      })
      .catch(() => {});
  }

  function openCart() {
    const drawer = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cartOverlay');
    if (drawer) drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    renderCartDrawer();
  }

  function closeCart() {
    const drawer = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cartOverlay');
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
  }

  function addToCart(id, name, price, emoji) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      updateCartCount();
      openCart();
    })
    .catch(() => {});
  }

  // ── FAQ ──
  function toggleFaq(btn) {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(f => f.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  }

  // ── Mobile nav ──
  function initMobileNav() {
    const hamburger = document.getElementById('hamburger');
    const mobileNav = document.getElementById('mobileNav');
    if (!hamburger) return;
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('open');
      mobileNav.classList.toggle('open');
    });
  }

  // ── Shop dropdown (desktop click) + mobile accordion ──
  function initShopDropdown() {
    const dd = document.getElementById('shopDropdown');
    const toggle = document.getElementById('shopDropdownToggle');
    if (dd && toggle) {
      toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = dd.classList.toggle('open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
      document.addEventListener('click', (e) => {
        if (!dd.contains(e.target)) {
          dd.classList.remove('open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          dd.classList.remove('open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    const mToggle = document.getElementById('mobileShopToggle');
    const mSub = document.getElementById('mobileShopSubmenu');
    if (mToggle && mSub) {
      mToggle.addEventListener('click', () => {
        const isOpen = mSub.classList.toggle('open');
        mToggle.classList.toggle('open', isOpen);
        mToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
  }

  // ── Language switcher dropdowns (desktop + mobile share this) ──
  function initLangSwitcher() {
    const switchers = document.querySelectorAll('.lang-switcher');
    if (!switchers.length) return;

    function closeAll() {
      switchers.forEach(s => {
        s.classList.remove('is-open');
        const t = s.querySelector('.lang-switcher-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    switchers.forEach(switcher => {
      const toggle = switcher.querySelector('.lang-switcher-toggle');
      if (!toggle) return;

      toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = switcher.classList.contains('is-open');
        closeAll(); // close any other open switcher first
        if (!isOpen) {
          switcher.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', (e) => {
      // close if click is outside ALL switchers
      let inside = false;
      switchers.forEach(s => { if (s.contains(e.target)) inside = true; });
      if (!inside) closeAll();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });
  }

  // ── Floating cart (mobile only) — peeks, reveals on interaction, auto-hides ──
  function initFloatingCart() {
    const cart = document.getElementById('floatingCart');
    if (!cart) return;

    let hideTimer = null;
    const HIDE_DELAY = 1000; // 1 second of inactivity → re-hide

    function reveal() {
      cart.classList.add('revealed');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        cart.classList.remove('revealed');
      }, HIDE_DELAY);
    }

    // Reveal on scroll (passive — won't block scrolling)
    let scrollTicking = false;
    window.addEventListener('scroll', () => {
      if (!scrollTicking) {
        requestAnimationFrame(() => {
          reveal();
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    }, { passive: true });

    // Reveal on hover/touch — keep it out while finger is on it
    cart.addEventListener('mouseenter', () => {
      cart.classList.add('revealed');
      clearTimeout(hideTimer);
    });
    cart.addEventListener('mouseleave', () => {
      hideTimer = setTimeout(() => {
        cart.classList.remove('revealed');
      }, HIDE_DELAY);
    });
    cart.addEventListener('touchstart', () => {
      cart.classList.add('revealed');
      clearTimeout(hideTimer);
    }, { passive: true });
    cart.addEventListener('touchend', () => {
      hideTimer = setTimeout(() => {
        cart.classList.remove('revealed');
      }, HIDE_DELAY);
    });
  }

  // ── NFC keychain tap animation ──
  function initNfcBanner() {
    const banner = document.getElementById('nfcBanner');
    const timerEl = document.getElementById('nfcTimer');
    const keychain = document.getElementById('nfcKeychain');
    const phone = document.getElementById('phoneWrap');
    if (!banner || !keychain) return;

    let timerInterval = null;

    function run() {
      let s = 0;

      const steps = [
        [0, () => {
          keychain.style.transition = 'transform 1.4s cubic-bezier(0.4,0,0.2,1), opacity 0.5s ease';
          keychain.style.opacity = '1';
          keychain.style.transform = 'translateX(-50%) translateY(0px)';
        }],
        [1400, () => {
          keychain.style.transition = 'transform 0.1s ease';
          keychain.style.transform = 'translateX(-50%) translateY(8px)';
          if (phone) { phone.style.transition = 'transform 0.07s ease'; phone.style.transform = 'translateY(-5px)'; }
        }],
        [1510, () => {
          if (phone) phone.style.transform = 'translateY(4px)';
        }],
        [1590, () => {
          if (phone) phone.style.transform = 'translateY(-3px)';
        }],
        [1670, () => {
          if (phone) phone.style.transform = 'translateY(2px)';
        }],
        [1750, () => {
          if (phone) { phone.style.transition = 'transform 0.3s ease'; phone.style.transform = 'translateY(0)'; }
        }],
        [1850, () => {
          s = 0;
          if (timerEl) timerEl.textContent = 'now';
          banner.style.transition = 'transform 0.5s cubic-bezier(0.34,1.4,0.64,1), opacity 0.4s ease';
          banner.style.transform = 'translateY(0)';
          banner.style.opacity = '1';
          clearInterval(timerInterval);
          timerInterval = setInterval(() => {
            s++;
            if (timerEl) timerEl.textContent = s + 's ago';
          }, 1000);
        }],
        [2400, () => {
          keychain.style.transition = 'transform 1.1s cubic-bezier(0.4,0,0.2,1), opacity 0.7s ease';
          keychain.style.transform = 'translateX(-50%) translateY(-160px)';
          keychain.style.opacity = '0';
        }],
        [window.innerWidth <= 768 ? 4200 : 5800, () => {
          clearInterval(timerInterval);
          banner.style.transition = 'transform 0.35s cubic-bezier(0.4,0,1,1), opacity 0.35s ease';
          banner.style.transform = 'translateY(-80px)';
          banner.style.opacity = '0';
        }],
      ];

      const isMobile = window.innerWidth <= 768;
      steps.forEach(([delay, fn]) => setTimeout(fn, delay));
      setTimeout(run, isMobile ? 5500 : 8500);
    }

    setTimeout(run, 1000);
  }

  // ── Init on DOM ready ──
  document.addEventListener('DOMContentLoaded', () => {
    initMobileNav();
    initShopDropdown();
    initLangSwitcher();
    initFloatingCart();
    initNfcBanner();
    updateCartCount();
    renderCartDrawer();
  });

  // Public API
  return { openCart, closeCart, addToCart, toggleFaq };

})();

// Expose closeMobileNav globally for inline onclick
function closeMobileNav() {
  document.getElementById('mobileNav')?.classList.remove('open');
  document.getElementById('hamburger')?.classList.remove('open');
}
